import React from "react";
import { useIntl } from "react-intl";
import type { DispatchType } from "src/dispatches/objects/DispatchType";

export interface DispatchTypeFormatterProps {
  children: DispatchType;
}

const getDispatchTypeMessageId = (dispatchType: DispatchType): string => {
  const typeMap: Record<string, string> = {
    SMS: "dispatches.type.sms",
    SMS_LIST: "dispatches.type.sms_list",
    EMAIL: "dispatches.type.email",
    FACEBOOK: "dispatches.type.facebook",
    MMS: "dispatches.type.mms",
  };
  return typeMap[dispatchType] || "ui.na";
};

export const DispatchTypeFormatter = ({
  children,
}: DispatchTypeFormatterProps) => {
  const intl = useIntl();
  const messageId = getDispatchTypeMessageId(children);
  return <>{intl.formatMessage({ id: messageId })}</>;
};
